import { styled } from "@mui/material/styles";

const ScrollableList = styled("div")(() => ({
  overflowY: "auto",
  overflowX: "hidden", // Use "hidden" to disable horizontal scrolling
  height: "calc(100vh - 100px)",
  "&::-webkit-scrollbar": {
    width: "5px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#d9d9d9",
    borderRadius: "5px",
    opacity: 0.3,
    transition: "opacity 0.3s ease",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#737373",
    opacity: 1,
  },
}));

export default ScrollableList;
